var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c(_vm.template,{tag:"component"},[(_vm.hasPermission)?_c('router-view',{key:_vm.$route.fullPath}):_c('div',[_vm._v("Sem permissão")])],1),_c('snackbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }